
define('main', ['require'],function (_) {
    return function (refpath, scriptspath, version) {
        var viewInit = function () {
            var args = arguments;
            requirejs.config({
                baseUrl: scriptspath,
                urlArgs: 'v=' + version
                //urlArgs: 'v=' + (new Date()).getTime()
            });
            requirejs([refpath,], function () {
                viewInit.startup.apply(this, args);
            });
        };
        viewInit.startup = function () {
            var args = arguments;
            requirejs(['lodash', 'jquery', 'current-locale','ko-hotkeys', 'ko-bootstrap', 'ko-dirty', 'ko-t','kodash', 'placeholder', 'resolveRelink', 'lodashPath', 'customBindings', 'knockout-repeat', 'modernizr', 'customBindings', 'text', 'json2','error'], function (_, $, locale) {
                var stringify = JSON.stringify;
                var opt = {clone:false};
                JSON.stringify = _.wrap(JSON.stringify,function(s,obj){
                    return s(_.resolve(obj));
                });
                JSON.parse = _.wrap(JSON.parse,function(p,str){
                    return _.relink(p(str));
                });
                locale($.i18n.lng());
                requirejs.apply(this, args);

                $(document).ready(function() {
                    setTimeout(
                        function() {
                            $(document.body).children().first().fadeIn();
                        }, 1000);
                });

            });
        };
        return viewInit;
    };

});

define('modernizr-private', ['modernizr'], function (md) { return md; });
require(['lodash', 'jquery', 'bootstrap'], function (_, $) {
    $('.dropdown-toggle').dropdown();
});